export const blogImages = import.meta.glob('$lib/assets/blogs/*.{jpeg,jpg,png}', {
	eager: true,
	query: {
		enhanced: true,
		w: '1280;640;320'
	}
});

export const enhancedImages = import.meta.glob('$lib/assets/enhanced/*.{jpeg,jpg,png}', {
	eager: true,
	query: {
		enhanced: true,
		w: '1280;640;320'
	}
});

export const highlightImages = import.meta.glob('$lib/assets/highlights/*.{jpeg,jpg,png}', {
	eager: true,
	query: {
		enhanced: true,
		w: '1280;640;320'
	}
});

export const illustrationImages = import.meta.glob('$lib/assets/illustrations/*.{jpeg,jpg,png}', {
	eager: true,
	query: {
		enhanced: true,
		w: '1280;640;320'
	}
});
